import apiRequest from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';
import { setLoading } from 'utilities/redux.actions';

function getCalenderName(calenders, id) {
    if (!calenders || !Array.isArray(calenders) || !id) {
        return id;
    }
    const calendar = calenders.find((item) => item.id === id);
    return calendar ? calendar.name : id;
}

function normalizeEmployeeInfo(data) {
    const {
        employeeId,
        joiningDate,
        reportingManager,
        department,
        branch,
        designation,
        employeeCategory,
        calenderId,
        user
    } = data || {};

    const normalized = {
        employeeEmail: user?.email
    };

    // Only add fields that have actual values
    if (employeeId) normalized.employeeId = employeeId;
    if (reportingManager) normalized.reportingManager = reportingManager;
    if (joiningDate) normalized.joiningDate = joiningDate;
    if (department?.name) normalized.department = department.name;
    if (branch?.name) normalized.officeBranch = branch.name;
    if (designation?.name) normalized.designation = designation.name;
    if (employeeCategory?.name)
        normalized.employeeCategory = employeeCategory.name;
    if (calenderId) normalized.calenderId = calenderId;

    return normalized;
}

export default function* (action) {
    const {
        meta: { handleSubmit = () => {} },
        payload: { employeeEmail }
    } = action;

    yield put(setLoading(true));

    try {
        const { data } = yield call(apiRequest, {
            url: `employee/get?email=${employeeEmail}`,
            method: 'get'
        });

        if (!data) {
            yield put(setLoading(false));
            return;
        }

        // Fetch calendar data
        let calenders = [];
        try {
            const {
                data: { data: calendersData }
            } = yield call(apiRequest, {
                url: `calender/get/all`,
                method: 'get'
            });
            calenders = calendersData || [];
        } catch (calendarError) {
            console.warn('Failed to fetch calendars:', calendarError);
        }

        const normalizedData = normalizeEmployeeInfo(data);

        // Convert calendar ID to name if we have calendar data
        if (data.calenderId) {
            const calendarName = getCalenderName(calenders, data.calenderId);
            normalizedData.calenderId = calendarName;
        }

        yield put(setLoading(false));
        return handleSubmit(normalizedData);
    } catch (error) {
        yield put(setLoading(false));
    }
}
